import { Injectable } from '@angular/core';

import {Observable, of} from 'rxjs';

import {HttpClient, HttpHeaders} from "@angular/common/http";

import {AppConsts} from "../appConsts";
import { map} from "rxjs/operators";



@Injectable()
export class FileService  {

  headers = new HttpHeaders()
    .set('content-type', 'application/json')
    .set('Access-Control-Allow-Origin', '*');
  constructor(private http: HttpClient) {}

  getDistributions() : Observable<any> {
    return this.http.get(AppConsts.remoteServiceBaseUrl + '/api/services/app/Distributor/GetAllDistributorsConsolidated?dataSource='+ AppConsts.JobFilesDataSource, {});
  }

  getFoldersForPath(path: string[], getFromDb?:boolean, datasource?: number) : Observable<any> {
    let url = "";
    const encodedPath = encodeURIComponent(path.filter(Boolean).join('/'));
    if(AppConsts.JobFilesDataSource == 1){
      url = `${AppConsts.remoteServiceBaseUrl}/api/services/app/TkeJobFiles/RetreiveFolderContents?storagePath=${encodedPath}`;
      url = getFromDb ? `${url}&getFromDb=true` : url;
      return this.http.post(url, {}, {headers: this.headers}).pipe(map((response:any) => {
        return response.result;
      }));
    }
    else{
      url = `${AppConsts.remoteServiceBaseUrl}/api/services/app/TkeJobFiles/RetreiveFolderContentsConsolidated?storagePath=${encodedPath}&dataSource=${datasource}`;
    }
    url = getFromDb ? `${url}&getFromDb=true` : url;
    return this.http.post(url, {}, {headers: this.headers}).pipe(map((response:any) => {
      return response.result;
    }));
  } 


  downloadFile(path: string[], fileName, openInBrowser?, dataSource?: number, isViewOrCopy?: boolean) : Observable<any> {
    let encodedPath = "";
    if(AppConsts.JobFilesDataSource == 1){
      encodedPath = `/api/services/app/TkeJobFiles/DownloadFile?storagePath=${encodeURIComponent(path.join('/'))}&fileName=${encodeURIComponent(fileName)}`;
      return this.postCallToDownloadFile(encodedPath, openInBrowser, dataSource);
    }else{
      if(dataSource == 1){
        encodedPath = `/api/services/app/TkeJobFiles/DownloadFile?storagePath=${encodeURIComponent(path.join('/'))}&fileName=${encodeURIComponent(fileName)}`;
      return this.postCallToDownloadFile(encodedPath, openInBrowser, dataSource);
      }
      else{
        encodedPath = `/api/services/app/TkeJobFiles/DownloadFileFromBlob?storagePath=${encodeURIComponent(path.join('/'))}&fileName=${encodeURIComponent(fileName)}&isViewOrCopy=${encodeURIComponent(isViewOrCopy)}`;
        return this.postCallToDownloadFile(encodedPath, openInBrowser, dataSource);
      }
    }
  }

  getSuggestionsForAutocomplete(search: string): Observable<any> {
    let url = "";
    if(AppConsts.JobFilesDataSource == 1){
      url = `${AppConsts.remoteServiceBaseUrl}/api/services/app/TkeJobFiles/SearchByJobNumberOrDistributor?searchText=${search}`
      return this.http.post(url, {})
    }
    else{
      url = `${AppConsts.remoteServiceBaseUrl}/api/services/app/TkeJobFiles/SearchByJobNumberOrDistributorConsolidated?searchText=${search}&dataSource=${AppConsts.JobFilesDataSource}`
      return this.http.post(url, {})
    }
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    if (/CriOS/.test(userAgent)) {
      return 'chrome-mobile';
    }

    //iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "Desktop";
  }

  postCallToDownloadFile(url:string, openInBrowser?, dataSource?: number) : Observable<any>{
    if(AppConsts.JobFilesDataSource === 1){
      return this.http.post(AppConsts.remoteServiceBaseUrl + url, {}, {headers: this.headers, responseType :
        'blob' as 'json'}).pipe(map((res:Blob) => {
          return new Blob([res], {type: this.getMobileOperatingSystem() === 'iOS' ? res.type : 'application/pdf' });
      }))
    }
    else{
      return this.http.post(AppConsts.remoteServiceBaseUrl + url, {}, {headers: this.headers, responseType :
        'blob' as 'json'}).pipe(map((res:Blob) => {
          return new Blob([res], {type: this.getMobileOperatingSystem() === 'iOS' ? res.type : 'application/pdf' });
      }))
    }
    
  }
}
